import { getCompanyLogo } from 'lib/api/company';
import { expressGetCompanyLogo } from 'lib/api/express';
import { showAlert } from 'lib/functions/utils';
import { Dispatch } from 'redux';
import { User } from 'services/redux/authSlice';

import { generateConfirmingSimulationPDF } from '../../exportSimulationConfirming';
import { ConfirmingCheckboxesState } from '../hooks/useConfirmingCheckboxes';
import { ConfirmingExportRequest } from '../types/ConfirmingExportRequest';

export interface ExportConfirmingSimulationOptions {
  dispatch: Dispatch;
  user: User;
  request: ConfirmingExportRequest;
  checkboxes: ConfirmingCheckboxesState;
}

export const handleExportConfirmingSimulation = async (
  options: ExportConfirmingSimulationOptions,
): Promise<void> => {
  const { dispatch, user, request } = options;

  try {
    // Obtener logo
    const imageBase64 = user?.express
      ? await expressGetCompanyLogo(dispatch, user.clientId as string)
      : await getCompanyLogo(dispatch);

    // Generar PDF
    await generateConfirmingSimulationPDF(
      request,
      user?.name || '',
      imageBase64,
    );

    showAlert(dispatch, 'success', 'Simulación exportada correctamente');
  } catch (error) {
    console.error(error);
    showAlert(dispatch, 'error', 'Error al exportar simulación');
    throw error;
  }
};
